<template>
  <div id="app">
    <!-- <section class="alert">
      <p class='alert__body'>
        <span class="alert__title">Comunicado: </span>
        A partir de los días <strong>09 (desde las 19:00 hrs.), 07, 08, 09 y 10 de enero del 2023</strong>,
        el servicio de la Apostilla entrará en mantenimiento programado.
        Gracias por su comprensión.
      </p>
    </section> -->

    <app-header></app-header>
    <main class="app-main">
      <transition :name="transitionName" mode="out-in">
        <router-view />
      </transition>
    </main>
    <app-footer></app-footer>
    <message></message>
    <confirm></confirm>
  </div>
</template>

<script>
import AppHeader from '@/components/layout/AppHeader';
import AppFooter from '@/components/layout/AppFooter';
import Message from '@/components/layout/Message';
import Confirm from '@/components/util/Confirm';

export default {
  name: 'app',
  data () {
    return {
      transitionName: ''
    };
  },
  components: {
    AppHeader,
    AppFooter,
    Message,
    Confirm
  },
  watch: {
    '$route' (to, from) {
      this.transitionName = 'fade';
    }
  }
};
</script>

<style lang="scss">
@import './assets/scss/main.scss';

.alert {
  background-color: #fdcb6e;
  padding: 20px 20px;
  text-align: center;
}

.alert__title {
  font-weight: bold;
  margin-bottom: 0px;
}

.alert__body {
  margin: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue